import React from "react";
import SectionHeading from "../UI/SectionHeading";

const steps = [
  {
    n: "01",
    title: "Free consultation",
    text: "We visit, listen to what you need and take measurements, then talk through ideas and options on the spot.",
  },
  {
    n: "02",
    title: "Design & quote",
    text: "You get a clear written quote and a design that suits your space, your finishes and your budget.",
  },
  {
    n: "03",
    title: "Handmade & fitted",
    text: "We build and install with care, keeping the site tidy and keeping you updated as the work progresses.",
  },
  {
    n: "04",
    title: "Finished & aftercare",
    text: "We walk through the finished work with you and stay on hand for any adjustments down the line.",
  },
];

export default function Process() {
  return (
    <section className="bg-paper">
      <div className="max-w-site mx-auto px-5 sm:px-10 py-16 md:py-24">
        <SectionHeading
          eyebrow="How it works"
          title="A simple, transparent process"
          intro="From first phone call to final walk-through, we keep things clear, tidy and on schedule."
          center
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {steps.map((s) => (
            <div key={s.n} className="relative bg-linen border border-hairline p-7 pt-10">
              <span className="absolute -top-5 left-7 font-display text-4xl font-semibold text-oak/30">
                {s.n}
              </span>
              <h3 className="font-display font-semibold text-xl text-ink">{s.title}</h3>
              <p className="text-bark leading-7 mt-3">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
